<template>
    <!--提现展示-->
    <div class="widthdrawal-container">
        <div class="main-container">
            <div class="flex flex-between">
                <p>您的现金红包余额(元)</p>
                <p class="widthdrawal-toggle-rule redColor" @click="showRuleBox(1)">红包提现规则</p>
            </div>
            <div class="flex flex-between widthdrawal-money-container">
                <div class="widthdrawal-money redColor"> 
                    <em class="money">{{storeState.balance || '0.00'}}</em>
                    <span class="tip">满10元可提现</span>
                </div>
                <template v-if="storeState.userInfo && storeState.userInfo.islogin && storeState.hasWX">
                     <button v-if="storeState.balance && storeState.balance>=10" @click="widthdrawalAction" class="widthdrawal-btn">马上提现</button>
                     <button v-else class="widthdrawal-btn disabled">马上提现</button>
                </template>
                <button v-else class="widthdrawal-btn wxAuth-btn" @click="wxAuthorize"></button>
            </div>
            <div class="money_end redColor">红包提现截止时间：2021年6月11日</div>
        </div>
        <div class="fund-container">
            <div class="flex flex-between">
                <p>您的购车券余额(元)</p>
                <em class="money redColor">{{storeState.fund || '0.00'}}</em>
            </div>
            <div class="fund-rule-bar">
                <div class="withdrawal_btn" @click="withdrawalShow" v-if="storeState.userInfo && storeState.userInfo.islogin && storeState.fund>0">提现</div>
                <div class="withdrawal_btn withdrawal_btn_disabled" @click="withdrawalDisabled" v-else>提现</div>
                <div class="fund-rule-btns">
                    <div class="fund-rule-btn fund-rule-txmx" @click="showRuleBox(4)" v-if="storeState.userInfo && storeState.userInfo.islogin">提现明细</div>
                    <div class="fund-rule-btn" @click="showRuleBox(2)">提现规则</div>
                </div>
           </div>
        </div>
    <div class="mask" v-if="rule_show>0">
        <div class="mask_rule_box" v-if="rule_show==1">
            <div class="mask_close" @click="hideRuleMask"></div>
            <div class="mask_rule_tit">【红包提现规则】</div>
            <div class="mask_rule_desc"><br>
                1、秒杀车型投票期间活动页面报名“参与红包任务”视为参与现金红包提现活动；<br><br>
                2、完成本次购车节活动页面相应活动任务，红包金额累计达到10元及以上即可提现；<br><br>
                3、2021年6月11日23:59:59后红包活动结束下线，红包金额未达到10元用户将无法提现领取；<br><br>
                4、2021年6月11日23:59:59后，达到提现金额的用户我们会在10个工作日内以微信红包形式发送给您（请提前添加“电动邦-邦小妹”企业微信为好友，并回复“购车节红包”）<br><br>
                5、红包提现活动仅限前1000名达到10元提现金额用户参与，先到先得，如提现人数已达到1000人红包提现活动将提前下线。
            </div>
        </div>
        <div class="mask_rule_box" v-else-if="rule_show==2">
            <div class="mask_close" @click="hideRuleMask"></div>
            <div class="mask_rule_tit">【购车券活动规则】</div>
            <div class="mask_rule_desc"><br>
                1、获得购车券的用户可在个人中心-购车券中查看当前获的补贴余额；<br><br>
                2、本次线下试驾会补贴购车券仅针对如下车型：几何A PRO和MARVEL R两款车型，试驾会的其余车型将不能享受本次购车券补贴。<br><br>
                3、该补贴金额有效期至2021年7月31日23:59:59前，过期将自动作废；<br><br>
                4、您可在最后截止期间内任意时段提交提现申请，审核通过后将在三个工作日内联系您为您发放补贴；<br><br>
                5、本次购车券为平台补贴，与厂商无关，实际产生的任何补贴金额与厂商无任何法律关系；<br><br>
                6、活动期间内购车补贴累计可提现的上限为3000元，超过此上限将不支持手动提交提现申请；<br><br>
            </div>
        </div>
        <div class="mask_submit_box" v-else-if="rule_show==3">
            <div class="mask_close" @click="hideRuleMask"></div>
            <div class="my_card my_submit_form_box">
                
                <label class="my_submit_form_item">
                    <div class="my_submit_form_item_attr">姓名</div>
                    <div class="my_submit_form_item_val">
                    <input type="text" v-model.trim="coupon_info.name">
                    </div>
                </label>
                <label class="my_submit_form_item">
                    <div class="my_submit_form_item_attr">联系电话</div>
                    <div class="my_submit_form_item_val">
                    <input type="tel" maxlength="11" v-model.trim="coupon_info.tel">
                    </div>
                </label>
                <label class="my_submit_form_item">
                    <div class="my_submit_form_item_attr">购车城市</div>
                    <div class="my_submit_form_item_val">
                    <input type="text" value="北京" readonly>
                    </div>
                </label>
                <label class="my_submit_form_item">
                    <div class="my_submit_form_item_attr">购车时间</div>
                    <div class="my_submit_form_item_val" >
                    <input type="text" v-show="!calendar_show" v-model.trim="coupon_info.time" @click="show_calendar">
    
                    </div>
                </label>
                <label class="my_submit_form_item">
                    <div class="my_submit_form_item_attr">车架号</div>
                    <div class="my_submit_form_item_val">
                    <input type="text" maxlength="17" v-model.trim="coupon_info.cjh">
                    </div>
                </label>
                <label class="my_submit_form_item">
                    <div class="my_submit_form_item_attr">购车4S店名称</div>
                    <div class="my_submit_form_item_val">
                    <input type="text" v-model.trim="coupon_info.dealer_name">
                    </div>
                </label>
                <div v-if="1" class="my_card my_submit_tip_info">
                    <div class="my_submit_tip_info_icon"></div>
                    <div class="my_submit_tip_info_text">以下信息仅用于审核邦基金和秒杀购车补贴，请确保信息填写准确，审核通过后工作人员与您取得联系</div>
                </div>
                <div class="my_submit_form_img">
                    <input id="uploadImg" class="uploadImg" type="file" @change="imgChange">
                    <img :src="img_data.img_url" alt="">
                </div>
                <div class="my_submit_form_btns">
                    <label class="my_submit_form_btn btn_gcfp" for="uploadImg">购车发票上传</label>
                    <div class="my_submit_form_btn btn_submit" @click="submitMessage">提交</div>
                </div>
            </div>
        
        </div>
        <div class="mask_txmx_box" v-else-if="rule_show==4">
            <div class="mask_close" @click="hideRuleMask"></div>
            <div class="mask_txmx_group">
                <div class="mask_txmx_item" v-for="(item,ind) in txmx_list" :key="ind">
                    <div class="mask_txmx_item_info">
                        <div class="mask_txmx_item_status">{{(item.status==0 || item.status==1)?"提现":"提现驳回"}}</div>
                        <div class="mask_txmx_item_money">{{(item.status==0 || item.status==1)?("-" + item.amount):("+" + item.amount)}}元</div>
                    </div>
                    <div class="mask_txmx_item_time">{{item.create_time}}</div>
                </div>
            </div>
        </div>
        <van-calendar v-model:show="calendar_show"  @confirm="onConfirm"/>
    </div>
    </div>
</template>
<script>
import { getQueryString } from "@/utils/util";
import { wxAuthorize, takeCash , takeCoupon ,imgAuth ,equityRecord} from '@/service/activity/brandWeek';
import BrandWeekStore from '@/store/modules/brandWeek';
import { getCookie } from '@/utils/cookie';
import { CONST_COOKIE_KEY_TOKEN } from '@/config/const';
import { Calendar } from 'vant';
export default {
  name: "Withdrawal",
  // props: {
  //     shareConfig: { type: Object, default: () => { return {} } },
  //     showShare: Boolean
  // },
  components: {
    "van-calendar":Calendar
  },
  emits: ['showRule'],
  data() {
    return {
        storeState: BrandWeekStore.state,
        code: '',
        appid: 'wxc010e27fc9191f47',
        isWx: window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger',
        rule_show:0,
        coupon_info:{
            name:"",
            tel:"",
            city:"北京",
            time:"",
            cjh:"",
            dealer_name:""
        },
        uploader:null,
        img_data:{
          img_url:'',
          isLoaded:false,
          progress:0
        },
        calendar_show:false,
        txmx_list:[]
        
    }
  },
  // watch: {
  //   color(newVal, oldVal){
  //     console.log(newVal, oldVal)
  //   }
  // },
  created() {
      this.requestAuthorize();
      this.uploaderInit();
  },
  mounted() {
  },
  unmounted() {
    //window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  methods: {
    widthdrawalAction(){
        const that = this;
        //点击马上提现
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '个人中心页', '点击马上提现']);
        if (!this.isWx){
            this.$toast('请在微信环境中提现！')
            return;
        }
        that.$session.loginScope(that.$parent.$refs.login,function(is_login){
            return new Promise(resolve=>{
                //本地校验已登录
                if (is_login){
                    that.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration: 0
                    });
                    takeCash().then(res=>{
                        res.name='takeCash';
                        if(typeof res == 'string'){
                            res = JSON.parse(res);
                        }
                        if(res.code==200) {
                            that.$toast.clear();
                            that.$toast('提现申请提交成功！');
                            BrandWeekStore.setBalance(0);
                            resolve(true)
                        } else if(res.code==501){
                            that.$toast.clear();
                            that.$session.update(false);
                            resolve(false);
                        } else {
                            that.$toast.clear();
                            that.$toast(res.message || '请求失败');
                        }
                    }).catch( err =>{
                        that.$toast.clear();
                        console.log('err', err);
                    })
                }
            })
        })
    },
    showRuleBox(type){
        const that = this;
        //type 1:红包提现规则 2:购车券提现规则 4:购车券提现明细
        // eslint-disable-next-line
        const type_text = type==2 ? '红包提现规则': (type==4 ? '购车券提现规则' : '');
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '个人中心页', '查看提现规则', type_text]);
        that.$toast.clear();
        if(type == 4){
            that.$session.loginScope(that.$refs.login, function(is_login){
                return new Promise(resolve=>{
                     if(is_login){
                        equityRecord().then(res=>{
                                if(res && res.code && res.code == 200){
                                    if(res.data.length<1){
                                        that.$toast("您还没有提现过！");
                                    }else{
                                        that.txmx_list = res.data;
                                        that.rule_show=type;
                                    }
                                    resolve(true);
                                }else if(res.code==501){
                                    that.$toast(res.message);
                                    resolve(false);
                                }else{
                                    that.$toast(res.message);
                                    resolve(true);
                                }
                            }).catch(()=>{
                                that.$toast.fail('请稍后重试！');
                                resolve(true)
                            })
                    }
                })
             
            })
        }else{
            that.rule_show=type;
        }
    },
    hideRuleMask(){
        this.rule_show=0;
    },
    requestAuthorize(){
        const that = this;
        //非微信环境加提示
       if (!this.isWx){
            return;
        }
        that.$session.loginScope(that.$parent.$refs.login,function(is_login){
            return new Promise(resolve => {
                //本地校验已登录
                if (is_login){
                    const code = getQueryString('code');
                    if(code && window.location.href.indexOf('param=wxlogin')>-1){
                        that.$toast.loading({
                            message: '加载中...',
                            forbidClick: true,
                            loadingType: 'spinner',
                            duration: 0
                        });
                        const data = {
                            code,
                            app_type: 'diandongbang',
                            token: getCookie(CONST_COOKIE_KEY_TOKEN) || '',
                        }
                        const _url = window.location.protocol + '//' +'zhuanti.diandong.com/zt/2021/8/autoshow/#/my';
                        window.history.pushState(null,null, _url);
                        wxAuthorize(data).then(res=>{
                            if (typeof res == 'string') {
                                res = JSON.parse(res);
                            }
                            if (res.code==200) {
                                that.$toast.clear();
                                BrandWeekStore.setHasWX(true);
                            } else if (res.code==501) {
                                BrandWeekStore.setHasWX(false);
                                that.$toast.clear();
                                that.$session.update(false);
                                resolve(false);
                            } else {
                                BrandWeekStore.setHasWX(false);
                                that.$toast.clear();
                                that.$toast(res.message || '请求失败');
                            }
                        }).catch( err =>{
                            BrandWeekStore.setHasWX(false);
                            that.$toast.clear();
                            console.log('err', err)
                        })
                    }
                }
            })
        })
    },
    wxAuthorize(){
        const that = this;
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '个人中心页', '点击微信授权']);
        //非微信环境加提示
        if (!this.isWx){
            this.$toast('请在微信环境中提现！')
            return;
        }
        that.$session.loginScope(that.$parent.$refs.login,function(is_login){
            return new Promise(resolve => {
                console.log(resolve)
                //本地校验已登录
                if (is_login){
                    // const url = window.location.href.split('?')[0];
                    let url = window.location.href.split('?');
                    url += '?param=wxlogin';
                    const code = getQueryString('code');
                    if (!code) {
                        // resolve(true);
                        window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appid + "&redirect_uri=" + encodeURIComponent(url) + "&response_type=code&scope=snsapi_userinfo#wechat_redirect");
                    }
                }
            })
        })
    },
    imgChange(e){
        console.log(e.target.files[0]);
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '个人中心页', '点击购车发票上传按钮']);
        const file = e.target.files[0];
        this.startUploadImgs(file);
    },
    uploaderInit(){
        const that = this;
/* eslint-disable */
        that.uploader =new AliyunUpload.Vod({
        userId:"LTAILYGBCb8TccgR", //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
        region: "cn-beijing", //上传到点播的地域
            //分片大小默认1 MB，不能小于100 KB
            partSize: 1048576,
        //并行上传分片个数，默认5
            parallel: 5,
        //网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        //网络原因失败时，重新上传间隔时间，默认为2秒
        retryDuration: 2,
            // 添加文件成功
            'addFileSuccess': function(res){
            console.log('addFileSuccess', res)
            that.uploader.startUpload();
            },
            // 开始上传
        'onUploadstarted': function (uploadInfo) {
            // let url = 'https://item.diandong.com/globals/photo/img-auth';
            that.$toast.loading({
            message: '上传中...',
            forbidClick: true,
            });
            let data = {};
            imgAuth(data).then(res=>{
            console.log(res)
            if(res && res.code == 0){
                let upload_data = res.data;
                console.log(upload_data)
                that.uploader.setUploadAuthAndAddress(uploadInfo, upload_data.upload_auth, upload_data.upload_address, upload_data.img_id);
                that.img_data={
                isLoaded:false
                };
            }else{ 
                console.log("失败")
                that.uploadFailFn(uploadInfo);
            }
            }).catch((err)=>{
            console.log("catch",err)
            that.uploadFailFn(uploadInfo);
            })
        },
        //文件上传成功
        'onUploadSucceed': function (uploadInfo) {
            console.log('onUploadSucceed', uploadInfo);
            that.img_data.isLoaded = true;
            that.img_data.img_url= 'https://alivideo.dd-img.com/' + uploadInfo.object;
        },
        // 文件上传失败
        'onUploadFailed': function (uploadInfo, code, message) {
            console.log("onUploadFailed: file:" + uploadInfo + ",code:" + code + ", message:" + message);
            that.uploadFailFn(uploadInfo);
        },
        // 文件上传进度，单位：字节
        // 'onUploadProgress': function (uploadInfo, totalSize, loadedPercent) {
        //   var progressPercent = Math.ceil(loadedPercent) + "%";
        //   that.img_data.progress=progressPercent;
        //   console.log(uploadInfo,progressPercent)
        // },
        //上传凭证超时
        'onUploadTokenExpired': function (uploadInfo) {
            console.log("onUploadTokenExpired");
            //实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
            //从点播服务刷新的uploadAuth，设置到SDK里
            that.uploader.resumeUploadWithAuth(uploadAuth);
        },
    });

/* eslint-enable */
    },
    startUploadImgs(file){
        var userData = '{"Vod":{}}';
        console.log(file)
        this.uploader.addFile(file, null, null, null, userData);
    },
    uploadFailFn(uploadInfo) {
        console.log("上传失败咯",uploadInfo)
    },
    show_calendar(){
        this.calendar_show = true;
    },
    onConfirm(val){
        this.coupon_info.time =val.toLocaleDateString().replace(/\//g,"-");
        this.calendar_show=false;
    },
    submitMessage(){
        const that = this;
        if(that.coupon_info.name.length<2 || that.coupon_info.name.length>25){
            that.$toast("请输入正确的姓名");
            return false;
        }
        if(that.coupon_info.tel == "" || !that.coupon_info.tel.startsWith("1") || that.coupon_info.tel.length!=11 ){
            that.$toast("手机号码格式有误");
            return false;
        }
        if(that.coupon_info.time == ""){
            that.$toast("请选择购车时间！");
            return false;
        }
        if(that.coupon_info.cjh.length<17){
            that.$toast("请输入正确的车架号！");
            return false;
        }
        if(that.coupon_info.dealer_name == ""){
            that.$toast("请输入购车4S店名称！");
            return false;
        }
        if(that.img_data.img_url == ""){
            that.$toast("请上传购车发票！");
            return false;
        }
        //添加百度统计代码
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '个人中心页', '点击提交按钮']);
        that.$toast.loading({
            message: '提交中...',
            forbidClick: true,
        });
        let data = {
            name:that.coupon_info.name,
            mobile:that.coupon_info.tel,
            city:that.coupon_info.city,
            buycar_time:that.coupon_info.time,
            car_num:that.coupon_info.cjh,
            dealer_name:that.coupon_info.dealer_name,
            invoice_img:that.img_data.img_url,
            balance_type:"ddb"
        };
        takeCoupon(data).then(res=>{
            if(res && res.code && res.code == 200){
            that.$toast("提交信息成功！");
            }else{
                that.$toast(res.message);
            }
            that.coupon_info.name = "";
            that.coupon_info.tel= "";
            that.coupon_info.time= "";
            that.coupon_info.cjh= "";
            that.coupon_info.dealer_name= "";
            that.img_data.img_url = "";
            that.rule_show = 0;
            BrandWeekStore.setFund(0);
        }).catch(()=>{
            that.$toast("提交失败,请稍后重试！");
            that.coupon_info.name = "";
            that.coupon_info.tel= "";
            that.coupon_info.time= "";
            that.coupon_info.cjh= "";
            that.coupon_info.dealer_name= "";
            that.img_data.img_url = "";
        })
    },
    withdrawalShow(){
        const that = this;
        that.$session.loginScope(that.$refs.login, function(is_login){
             return new Promise(resolve=>{
                if (is_login){
                    that.rule_show = 3;
                    resolve(true)
                }
             })
            
        })
    },
    withdrawalDisabled(){
        this.$toast("您的提现余额不足！");
    }
  },
};
</script>
<style lang="less">
    @redColor: #d98766;
    .redColor{
        color: @redColor;
    }
  .widthdrawal-container{
      margin: 0 33px 24px 33px;
      padding: 22px;
      background: #fff;
      border-radius: 26px;
      color: #333;
      font-size: 26px;
      line-height: 1.5;
      em{
          font-style: normal;
      }
      .widthdrawal-toggle-rule{
          font-size: 24px;
          text-decoration: underline;
      }
    .main-container{
        padding: 35px 27px 8px 44px;
        overflow: hidden;
        background: url(../../assets/images/brandWeek/withdrawl_main_bg.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 26px;
        .money_end{
            height: 80px;
            line-height: 80px;
            font-size: 18px;
        }
        .widthdrawal-money-container{
            margin-top: 22px;
            .widthdrawal-money{
                position: relative;
                line-height: 1;
                .money{
                    font-size: 80px;
                    font-weight: bold;
                    flex: 1;
                    font-family: Arial, Helvetica, sans-serif;
                }
                .tip{
                    position: relative;
                    top: -30px;
                    height: 30px;
                    padding: 0 15px 0 12px;
                    line-height: 29px;
                    margin-left: 16px;
                    font-size: 18px;
                    border: 1px solid @redColor;
                    border-radius: 50px 50px 50px 0;
                }
            }
            .widthdrawal-btn{
                width: 170px;
                height: 59px;
                line-height: 58px;
                color: #fff;
                font-weight: bold;
                font-size: 28px;
                background: @redColor;
                outline: none;
                border: none;
                -webkit-appearance: none;
                appearance: none;
                border-radius: 50px;
                &.disabled{
                    background: #cdcccc;
                }
                &.wxAuth-btn{
                    background: url(../../assets/images/brandWeek/wxAuth-btn.png) no-repeat center center;
                    background-size: 100%;
                }
            }
        }
    }
    .fund-container{
        line-height: 1.4;
        padding: 32px 27px 12px 27px;
        .money{
            font-size: 54px;
            font-weight: bold;
            font-family: Arial, Helvetica, sans-serif;
        }
        .fund-rule-bar{
            display: flex;
            justify-content: space-between;
            align-content: center;
            .withdrawal_btn{
                width: 220px;
                height: 50px;
                line-height: 51px;
                border-radius: 25px;
                color: #fff;
                text-align: center;
                font-size: 26px;
                background: #cd8a6d;
                &.withdrawal_btn_disabled{
                    background: #ccc;
                }
            }
            .fund-rule-btns{
                height: 46px;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                .fund-rule-btn{
                    width: 130px;
                    height: 32px;
                    line-height: 33px;
                    font-size: 24px;
                    color: #808080;
                    text-align: center;
                    border-radius: 16px;
                    border: solid 1PX #808080;
                    &.fund-rule-txmx{
                        margin-right: 20px;
                    }
                }
            }
            
        }
      
    }
  }



  .mask{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .5);
      z-index: 998;
  }
  .mask_rule_box{
    width: 560px;
    padding:50px 45px;
    max-height: 690px;
    border-radius: 17px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,calc(-80px - 50%));
  }
  .mask_rule_tit{
    line-height: 34px;
    text-align: left;
    font-size: 26px;
    font-weight: bold;
    color: #333333;
  }
  .mask_rule_desc{
    text-align: left;
    max-height: 560px;
    overflow-y: scroll;
    line-height: 30px;
    font-size: 24px;
    color: #333333;
  }
  .mask_close{
      width: 72px;
      height: 72px;
      background: url(../../assets/images/brandWeek/login_close.png) no-repeat;
      background-size: 100%;
      position: absolute;
      bottom: -90px;
      left: 50%;
      transform: translateX(-50%);
  }

  .mask_submit_box{
      width: 684px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,calc(-50% - 50px));
      background: #fff;
      border-radius: 22px;
      padding: 10px 22px 0;

  }

  .my_submit_tip_info{
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding: 0 30px;
    }
  .my_submit_tip_info_icon{
    width: 60px;
    height: 60px;
    background: url(../../assets/images/brandWeek/icon_info.png) no-repeat center center;
    background-size: 35px 35px;
    flex-shrink: 0;
  }
  .my_submit_tip_info_text{
    padding: 5px;
    font-size: 22px;
    color: #7a7a96;
    text-align: left;
  }

  .my_submit_form_item{
    display: flex;
    align-items: flex-end;
    height: 80px;
    padding-right: 50px;
  }
  .my_submit_form_item_attr{
    height: 32px;
    line-height: 32px;
    font-size: 28px;
    color: #7a7a96;
    min-width: 200px;
    padding-left: 36px;
    padding-right: 55px;
    white-space: nowrap;
    flex-shrink: 0;
    text-align: left;
  }
  .my_submit_form_item_val{
    flex-grow: 1;
    display: flex;
    align-items: flex-end;
  }
  .my_submit_form_item_val input{
    width: 100%;
    height: 32px;
    border: none;
    border-bottom: solid 1PX #c0c0c0;
    font-size: 26px;
    padding: 0 40px;
  }

  .my_submit_form_img{
    width: 429px;
    height: 198px;
    overflow: hidden;
    position: relative;
    margin: 20px auto 0;
    background: url(../../assets/images/brandWeek/upload.png) no-repeat center center;
    background-size: 100px 100px;
    border: solid 1PX #ccc;
    border-radius: 5px;
  }
  .my_submit_form_img img{
    display: block;
    width: 100%;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .uploadImg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
  }
  .my_submit_form_btns{
    display: flex;
    padding: 35px 25px 46px;
    justify-content: space-between;
  }
  .my_submit_form_btn.btn_gcfp{
    width: 232px;
    height: 80px;
    line-height: 80px;
    border-radius: 40px;
    text-align: center;
    font-size: 28px;
    background: #eaeaea;
    color: #5f5f5f;
  }
  .my_submit_form_btn.btn_submit{
    width: 315px;
    height: 80px;
    line-height: 80px;
    border-radius: 40px;
    text-align: center;
    font-size: 32px;
    background: #8f4ed5;
    color: #fff;
  }

.mask_txmx_box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    padding: 52px;
    border-radius: 22px;
    background: #fff;
    width: 625px;
    .mask_txmx_group{
        max-height:800px;
        overflow-y: scroll;
        .mask_txmx_item{
            width: 100%;
            padding: 60px 0 32px;
            border-bottom: solid 1PX #999999;
            &:last-child{
                border:none;
            }
            .mask_txmx_item_info{
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 40px;
                .mask_txmx_item_status{
                    font-size: 32px;
                    color: #333333;
                }
                .mask_txmx_item_money{
                    font-size: 28px;
                    color: #808080;
                }
            }
            .mask_txmx_item_time{
                line-height: 70px;
                font-size: 28px;
                color: #808080;
                text-align: right;
            }
        }
    }
    
}

</style>